// test1402
(1402 && 0);
